<template>
	<div>
		<div class="div-content-left-image">
			<img :src="imageData.length>imageIndex?imageData[imageIndex].url:''" />
		</div>
		<div class="div-content-left-image-index">
			<div class="div-content-left-image-index-left" @click='imageIndex > 0 ?imageIndex--:imageIndex = 0;'>
				<Icon type="ios-arrow-back" size='24'/>
			</div>
			<div class="div-content-left-image-index-center">
				<img v-for="(item,index) in imageData" :src="item.url" :class="index == imageIndex?'selected-image':''" @click="imageIndex = index;"/>
			</div>
			<div class="div-content-left-image-index-right" @click='(imageIndex+1) < imageData.length  ?imageIndex++:imageIndex = imageIndex;'>
				<Icon type="ios-arrow-forward" size='24'/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'imagepage',
        props: {
        	imageData: {
        		type: Array
        	}
		},
		data() {
			return {
				imageIndex:0
			}
		},
		methods: {
		},
		watch: {
		},
		created: function() {
		},
		mounted() {
		}
	}
</script>

<style scoped>
	.div-content-left-image{
	}
	
	.div-content-left-image img{
		width: 300px;
		height: 300px;
		border-radius: 3px;
	}
	
	.div-content-left-image-index{
		overflow: hidden;
		width: 300px;
	}
	
	.div-content-left-image-index-left{
		float: left;
		width: 6%;
		display: flex;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}
	
	.div-content-left-image-index-left:hover{
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}
	
	.div-content-left-image-index-center{
		float: left;
		width: 88%;
		overflow-y: auto;
		padding: 0px 4px;
	}
	.div-content-left-image-index-center img{
		width: 44px;
		height: 44px;
		cursor: pointer;
		margin-right: 4px;
	}
	
	.selected-image{
		border: rgb(255, 106, 127) 1px solid;
	}
	
	.div-content-left-image-index-right{
		float: right;
		width: 6%;
		display: flex;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}
	
	.div-content-left-image-index-right:hover{
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}
	
</style>